import { createBrowserRouter } from "react-router-dom"
import MainLayout from "@/components/layout/main-layout"
import BlankLayout from "@/components/layout/blank-layout"
import ct from "@constants/"
import dashboardRoutes from "./main.routes"
import blankRoutes from "./blank.routes"

const router = createBrowserRouter([
  {
    path: ct.route.ROOT,
    element: <MainLayout />,
    children: dashboardRoutes,
  },
  {
    element: <BlankLayout />,
    children: blankRoutes,
  },
])

export default router
